<template>
  <div class="ocr-info">
    <div class="header-box">
      <div class="title-box">{{titleList[type]}}</div>
      <div class="tipes-box">证件信息错误可能导致拒签，请仔细核对</div>
      <div class="edit-btn-box" @click="editInfo" v-if="readOnly && shouldShowEdit && !forbid">修改信息</div>
    </div>


    <form-info
      :type="type"
      :formData="infoData"
      ref="formInfo"
      :applicantId="applicantId"
      :orderId="orderId"
      :currentMaterial="currentMaterial"
      :readOnly="readOnly"
      :order="order"
      @updateOrder="updateOrder">
    </form-info>
  </div>
</template>

<script>

import formInfo from './form-info';

export default {
  name: 'ocr-info',
  components: {
    formInfo,
  },
  props: {
    type: {
      type: String,
      required: true,
      default: '',
    },
    orderId: {
      type: Number,
      required: true,
    },
    applicantId: {
      type: Number,
      required: true,
    },
    currentMaterial: {
      type: Object,
      required: true,
      default: () => ({}),
    },
    infoData: {
      type: Object,
      required: true,
      default: () => ({}),
    },
    shouldShowEdit: {
      type: Boolean,
      default: true,
    },
    forbid: {
      // 是否禁用
      type: Boolean,
      default: false,
    },
    order: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      titleList: {
        passport: '护照信息读取',
        idcarda: '身份证人像面读取',
        idcardb: '身份证国徽面读取',
      },
    };
  },
  computed: {
    readOnly: {
      get() {
        return this.infoData.isConfirm;
      },
      set(val) {
        this.infoData.isConfirm = val;
      },
    },
  },
  methods: {
    checkValid() {
      this.$refs.formInfo.checkValid();
    },
    saveOtherPlace() {
      this.$refs.formInfo.saveOtherPlace();
    },
    updateOrder() {
      this.readOnly = true;
      this.$emit('updateOrder');
    },
    editInfo() {
      this.saveOtherPlace();
      this.readOnly = false;
    },
    initData() {
      this.checkValid();
      this.readOnly = false;
    },
  },

};
</script>

<style lang="less" scoped>

.ocr-info {
  .header-box{
    display: flex;
    align-items: center;
    margin-bottom: 10px;
    .title-box{
      font-size: 16px;
      color: #333333;
      font-weight: 600;
    }
    .tipes-box{
      flex: 1;
      font-size: 14px;
      color: #ff5a60;
      position: relative;
      padding-left: 44px;
      &::before{
        content: '';
        width: 16px;
        height: 16px;
        position: absolute;
        left: 20px;
        top: -1px;
        background-image: url('../../../assets/imgs/admin-order/notice.png');
        background-size: cover;
        background-repeat: no-repeat;
      }
    }
    .edit-btn-box{
      color: #5e9be1;
      font-size: 14px;
      position: relative;
      cursor: pointer;
      &::before{
        content: '';
        width: 16px;
        height: 16px;
        position: absolute;
        left: -24px;
        top: -1px;
        background-image: url('../../../assets/imgs/upload/edit-ocr.png');
        background-size: cover;
        background-repeat: no-repeat;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/upload/ocr-info/ocr-info.vue